export const sanitizeUrl = (url: string): string => {
    if (url.startsWith('http://')) {
        return url.replace('http://', 'https://');
    }
    return url;
};
